/* Guided size finder (blocks/_pb-size-finder.liquid).
 * Estimates body chest / waist from height, weight, age and body-shape answers, then picks the first size of the
 * product's size chart whose garment chest (and waist, if present) leaves the chosen amount of room. */
(function () {
  var SVG = {
    chest: function (v) { // front torso; v: -1 narrower, 0 average, 1 broader
      var w = 20 + v * 4, l = 40 - w, r = 40 + w;
      return '<svg viewBox="0 0 80 80" aria-hidden="true" focusable="false">' +
        '<circle class="pb-sf__body" cx="40" cy="11" r="6.5"/>' +
        '<path class="pb-sf__body" d="M35 19c1 2 3 3 5 3s4-1 5-3l' + (r - 46) + ' 6c3 1 5 4 5 8v40H' + l + 'V33c0-4 2-7 5-8z"/>' +
        '<path class="pb-sf__body-hi" d="M' + (l - 6) + ' 30c-4 7-4 16-2 24M' + (r + 6) + ' 30c4 7 4 16 2 24"/></svg>';
    },
    stomach: function (v) { // side profile; belly curve
      var b = [-3, 3, 9][v + 1], f = 60 + b;
      return '<svg viewBox="0 0 80 80" aria-hidden="true" focusable="false">' +
        '<path class="pb-sf__body" d="M30 74V24c0-8 6-12 12-12h4c4 0 6 3 6 7v6c0 3 3 5 6 7s5 6 5 10c0 4 ' + (b + 2) + ' 10 ' + (b + 2) + ' 16s-3 10-5 16z"/>' +
        '<path class="pb-sf__body-hi" d="M' + (f + 5) + ' 40c4 8 4 16 0 26"/></svg>';
    },
    seat: function (v) { // side profile; seat curve
      var b = [-2, 3, 8][v + 1];
      return '<svg viewBox="0 0 80 80" aria-hidden="true" focusable="false">' +
        '<path class="pb-sf__body" d="M52 6H34v20c0 4-' + (b + 4) + ' 8-' + (b + 6) + ' 16s' + (b + 2) + ' 14 ' + (b + 6) + ' 18v14h18V60c4-4 6-12 6-20s-4-12-6-16z"/>' +
        '<path class="pb-sf__body-hi" d="M' + (24 - b) + ' 34c-5 8-5 18 0 26"/></svg>';
    }
  };
  var CHEV = '<svg class="pb-sf__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  function esc(str) { return String(str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }

  // Chart parsing: labels ["Shoulder","Sleeve","Length","1/2 Chest"], rows "SIZE|in|cm|in|cm|..."
  function parseChart(cfg) {
    var labels = cfg.labels || [];
    var find = function (re) { for (var i = 0; i < labels.length; i++) if (re.test(labels[i])) return i; return -1; };
    var ci = find(/chest|bust/i), wi = find(/waist/i);
    if (ci < 0) return null;
    var halfC = /1\s*\/\s*2|half/i.test(labels[ci]), halfW = wi > -1 && /1\s*\/\s*2|half/i.test(labels[wi]);
    var sizes = [];
    (cfg.rows || []).forEach(function (row) {
      var c = row.split('|').map(function (x) { return x.trim(); });
      if (c.length < 2 * labels.length + 1) return;
      var chest = num(c[ci * 2 + 2]), waist = wi > -1 ? num(c[wi * 2 + 2]) : null;
      if (chest === null) return;
      sizes.push({ name: c[0].toUpperCase(), chest: chest * (halfC ? 2 : 1), waist: waist === null ? null : waist * (halfW ? 2 : 1) });
    });
    return sizes.length ? sizes : null;
  }

  // Effect of an answer (-2..2) on the body estimate, in cm.
  var EFFECT = { chest: [-5, -3, 0, 4, 7], stomach: [-7, -4, 0, 6, 10], seat: [-3, -1, 0, 2, 4] };
  function eff(key, v) { v = v === null || v === undefined ? 0 : v; return EFFECT[key][Math.max(-2, Math.min(2, v)) + 2]; }

  // Body estimate in cm. Simple anthropometric regressions on BMI + height, tuned for casual shirts.
  function estimate(a) {
    var h = a.heightCm, kg = a.weightKg, bmi = kg / Math.pow(h / 100, 2);
    var chest, waist;
    if (a.gender === 'women') { chest = 26 + 3.0 * bmi + 0.12 * (h - 163); waist = -4 + 3.4 * bmi + 0.05 * (h - 163); }
    else { chest = 22 + 3.2 * bmi + 0.15 * (h - 175); waist = 2 + 3.4 * bmi + 0.05 * (h - 175); }
    if (a.age && a.age >= 45) { chest += 1; waist += 3; }
    chest += eff('chest', a.chest);
    waist += eff('stomach', a.stomach) + eff('seat', a.seat);
    return { chest: Math.round(chest * 10) / 10, waist: Math.round(waist * 10) / 10, bmi: bmi };
  }
  function easeFor(cfg, v) {
    v = v === null || v === undefined ? 0 : v;
    var e = cfg.ease;
    return [Math.max(0, e.slim - 3), e.slim, e.regular, e.loose, e.loose + 4][Math.max(-2, Math.min(2, v)) + 2];
  }

  function recommend(sizes, body, ease) {
    var needC = body.chest + ease, needW = body.waist + ease * 0.8, idx = -1, i;
    for (i = 0; i < sizes.length; i++) if (sizes[i].chest >= needC) { idx = i; break; }
    var widx = -1;
    if (sizes[0].waist !== null) for (i = 0; i < sizes.length; i++) if (sizes[i].waist !== null && sizes[i].waist >= needW) { widx = i; break; }
    var largest = false;
    if (idx < 0 || (sizes[0].waist !== null && widx < 0)) { idx = sizes.length - 1; largest = true; }
    else idx = Math.max(idx, widx);
    return { index: idx, size: sizes[idx], largest: largest, smaller: sizes[idx - 1] || null, larger: sizes[idx + 1] || null };
  }

  function SizeFinder(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-sf-config]').textContent);
    this.dialog = root.querySelector('dialog');
    this.stepsEl = root.querySelector('[data-sf-steps]');
    this.dotsEl = root.querySelector('[data-sf-dots]');
    this.nextBtn = root.querySelector('[data-sf-next]');
    this.prevBtn = root.querySelector('[data-sf-prev]');
    this.loading = root.querySelector('[data-sf-loading]');
    this.sizes = parseChart(this.cfg);
    // Questions come from child "answer" blocks: keep order, 2..4 answers per question.
    var byQ = {}, orderQ = [];
    root.querySelectorAll('[data-sf-option]').forEach(function (el) {
      var o; try { o = JSON.parse(el.textContent); } catch (e) { return; }
      if (!o || !o.q || !o.label) return;
      if (!byQ[o.q]) { byQ[o.q] = []; orderQ.push(o.q); }
      if (byQ[o.q].length < 4) byQ[o.q].push({ label: o.label, effect: parseInt(o.effect, 10) || 0, image: o.image || '' });
    });
    this.questions = orderQ.filter(function (q) { return byQ[q].length >= 2 && ['chest', 'stomach', 'seat', 'fit'].indexOf(q) > -1; })
      .map(function (q) { return { key: q, options: byQ[q] }; });
    this.reset();
    var self = this;
    root.querySelector('[data-sf-open]').addEventListener('click', function () { self.open(); });
    root.querySelector('[data-sf-close]').addEventListener('click', function () { self.close(); });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
    this.nextBtn.addEventListener('click', function () { self.next(); });
    this.prevBtn.addEventListener('click', function () { self.go(self.step - 1); });
  }
  SizeFinder.prototype.reset = function () {
    this.step = 0;
    this.a = { gender: 'men', units: this.cfg.units === 'metric' ? 'metric' : 'imperial', ft: '', inch: '', cm: '', lbs: '', kg: '', age: '', chest: null, stomach: null, seat: null, fit: null };
  };
  SizeFinder.prototype.open = function () {
    this.reset();
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
    document.documentElement.classList.add('pb-sf-open');
    this.render();
  };
  SizeFinder.prototype.close = function () {
    if (this.dialog.open) this.dialog.close(); else this.dialog.removeAttribute('open');
    document.documentElement.classList.remove('pb-sf-open');
    this.loading.hidden = true;
  };
  SizeFinder.prototype.total = function () { return this.questions.length + 2; }; // details + questions + result
  SizeFinder.prototype.isResult = function () { return this.step === this.total() - 1; };
  SizeFinder.prototype.question = function () { return this.step >= 1 && !this.isResult() ? this.questions[this.step - 1] : null; };
  SizeFinder.prototype.go = function (n) { this.step = Math.max(0, Math.min(this.total() - 1, n)); this.render(); };
  SizeFinder.prototype.next = function () {
    if (this.step === this.total() - 2) return this.finish();
    this.go(this.step + 1);
  };
  SizeFinder.prototype.valid = function () {
    if (this.step === 0) return this.heightCm() > 100 && this.weightKg() > 25;
    var q = this.question();
    return q ? this.a[q.key] !== null : false;
  };
  SizeFinder.prototype.heightCm = function () {
    var a = this.a;
    if (a.units === 'metric') return num(a.cm) || 0;
    return ((num(a.ft) || 0) * 12 + (num(a.inch) || 0)) * 2.54;
  };
  SizeFinder.prototype.weightKg = function () {
    var a = this.a;
    return a.units === 'metric' ? (num(a.kg) || 0) : (num(a.lbs) || 0) * 0.4536;
  };
  SizeFinder.prototype.render = function () {
    var t = this.cfg.t, a = this.a, self = this, html = '';
    var steps = this.total(), i;
    this.dotsEl.innerHTML = '';
    for (i = 0; i < steps; i++) this.dotsEl.innerHTML += '<i' + (i === this.step ? ' class="is-active"' : '') + '></i>';
    this.prevBtn.hidden = this.step === 0 || this.isResult();
    this.nextBtn.hidden = this.isResult();

    if (this.step === 0) {
      var metric = a.units === 'metric';
      html += '<h2 class="pb-sf__heading">' + esc(t.details) + '</h2>';
      if (this.cfg.askGender) {
        html += '<div class="pb-sf__card"><span class="pb-sf__card-label">' + esc(t.gender) + '</span><div class="pb-sf__seg">' +
          '<button type="button" data-set="gender" data-val="men" aria-pressed="' + (a.gender === 'men') + '">' + esc(t.men) + '</button>' +
          '<button type="button" data-set="gender" data-val="women" aria-pressed="' + (a.gender === 'women') + '">' + esc(t.women) + '</button></div></div>';
      }
      html += '<div class="pb-sf__card"><span class="pb-sf__card-label">' + esc(t.height) + '</span><div class="pb-sf__fields">' +
        (metric
          ? '<label class="pb-sf__field"><input type="number" inputmode="decimal" min="100" max="230" data-in="cm" value="' + esc(a.cm) + '"><small>' + esc(t.cm) + '</small></label>'
          : '<label class="pb-sf__field"><input type="number" inputmode="numeric" min="3" max="7" data-in="ft" value="' + esc(a.ft) + '"><small>' + esc(t.feet) + '</small></label>' +
            '<label class="pb-sf__field"><input type="number" inputmode="numeric" min="0" max="11" data-in="inch" value="' + esc(a.inch) + '"><small>' + esc(t.inches) + '</small></label>') +
        '</div><div class="pb-sf__units"><button type="button" data-units="imperial" aria-pressed="' + !metric + '">' + esc(t.feet) + '</button><button type="button" data-units="metric" aria-pressed="' + metric + '">' + esc(t.cm) + '</button></div></div>';
      html += '<div class="pb-sf__card"><span class="pb-sf__card-label">' + esc(t.weight) + '</span><div class="pb-sf__fields">' +
        (metric
          ? '<label class="pb-sf__field"><input type="number" inputmode="decimal" min="25" max="250" data-in="kg" value="' + esc(a.kg) + '"><small>' + esc(t.kg) + '</small></label>'
          : '<label class="pb-sf__field"><input type="number" inputmode="numeric" min="60" max="550" data-in="lbs" value="' + esc(a.lbs) + '"><small>' + esc(t.lbs) + '</small></label>') +
        '</div><div class="pb-sf__units"><button type="button" data-units="imperial" aria-pressed="' + !metric + '">' + esc(t.lbs) + '</button><button type="button" data-units="metric" aria-pressed="' + metric + '">' + esc(t.kg) + '</button></div></div>';
      html += '<div class="pb-sf__card"><span class="pb-sf__card-label">' + esc(t.age) + '</span><div class="pb-sf__fields">' +
        '<label class="pb-sf__field"><input type="number" inputmode="numeric" min="10" max="110" data-in="age" value="' + esc(a.age) + '"><small>' + esc(t.years) + '</small></label></div><span></span></div>';
    } else if (this.question()) {
      var q = this.question(), key = q.key;
      html += '<h2 class="pb-sf__heading">' + esc(t[key]) + '</h2><div class="pb-sf__options">';
      q.options.forEach(function (o) {
        var v = Math.max(-1, Math.min(1, o.effect));
        var icon = o.image ? '<img class="pb-sf__option-img" src="' + esc(o.image) + '" alt="" loading="lazy">' : (key === 'fit' ? SVG.chest(v) : SVG[key](v));
        html += '<button type="button" class="pb-sf__option" data-set="' + key + '" data-val="' + o.effect + '" aria-pressed="' + (a[key] === o.effect) + '">' + icon + '<span>' + esc(o.label) + '</span>' + CHEV + '</button>';
      });
      html += '</div>';
    } else {
      html += this.resultHTML();
    }
    this.stepsEl.innerHTML = html;
    this.stepsEl.scrollTop = 0;
    this.nextBtn.disabled = !this.valid();

    this.stepsEl.querySelectorAll('[data-in]').forEach(function (inp) {
      inp.addEventListener('input', function () { a[inp.dataset.in] = inp.value; self.nextBtn.disabled = !self.valid(); });
    });
    this.stepsEl.querySelectorAll('[data-units]').forEach(function (b) {
      b.addEventListener('click', function () { a.units = b.dataset.units; self.render(); });
    });
    this.stepsEl.querySelectorAll('[data-set]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.set, v = b.dataset.val;
        a[k] = k === 'gender' ? v : parseInt(v, 10);
        if (k === 'gender') { self.render(); return; }
        self.render();
        setTimeout(function () { self.next(); }, 180);
      });
    });
    var first = this.stepsEl.querySelector('input, button');
    if (first && this.step === 0) first.focus();
  };
  SizeFinder.prototype.finish = function () {
    var self = this, cards = this.loading.querySelectorAll('[data-sf-lcard]');
    if (!cards.length) { this.go(this.total() - 1); return; }
    this.loading.hidden = false;
    cards.forEach(function (c) { c.classList.remove('is-active', 'is-done'); });
    var i = 0;
    var tick = function () {
      if (i > 0) { cards[i - 1].classList.remove('is-active'); cards[i - 1].classList.add('is-done'); }
      if (i < cards.length) { cards[i].classList.add('is-active'); i++; setTimeout(tick, 900); }
      else { setTimeout(function () { self.loading.hidden = true; self.go(self.total() - 1); }, 250); }
    };
    tick();
  };
  SizeFinder.prototype.resultHTML = function () {
    var t = this.cfg.t, a = this.a, self = this;
    if (!this.sizes) return '<h2 class="pb-sf__heading">' + esc(t.result) + '</h2><p class="pb-sf__error">' + esc(t.noChart) + '</p>';
    var body = estimate({ heightCm: this.heightCm(), weightKg: this.weightKg(), age: num(a.age), gender: a.gender, chest: a.chest, stomach: a.stomach, seat: a.seat });
    var ease = easeFor(this.cfg, a.fit);
    var r = recommend(this.sizes, body, ease);
    var inProduct = (this.cfg.productSizes || []).some(function (v) { return String(v).toUpperCase() === r.size.name; });
    var alt = t.resultAlt.replace('[smaller]', r.smaller ? r.smaller.name : '—').replace('[larger]', r.larger ? r.larger.name : '—');
    var html = '<div class="pb-sf__result"><h2 class="pb-sf__heading">' + esc(t.result) + '</h2>' +
      '<div class="pb-sf__size">' + esc(r.size.name) + '</div>' +
      '<p class="pb-sf__note">' + esc(t.resultNote) + (r.largest ? ' ' + esc(t.resultLargest) : '') + '</p>' +
      '<div class="pb-sf__compare"><div><span>' + esc(t.bodyChest) + '</span><b>' + fmt(body.chest, a.units) + '</b></div>' +
      '<div><span>' + esc(t.garmentChest) + ' (' + esc(r.size.name) + ')</span><b>' + fmt(r.size.chest, a.units) + '</b></div></div>' +
      (r.smaller || r.larger ? '<p class="pb-sf__alt">' + esc(alt) + '</p>' : '') +
      '<button type="button" class="pb-sf__select" data-select="' + esc(r.size.name) + '"' + (inProduct ? '' : ' disabled') + '>' + esc(t.select.replace('[size]', r.size.name)) + '</button>' +
      '<div><button type="button" class="pb-sf__restart" data-restart>' + esc(t.restart) + '</button></div></div>';
    setTimeout(function () {
      var sel = self.stepsEl.querySelector('[data-select]'), rs = self.stepsEl.querySelector('[data-restart]');
      if (sel) sel.addEventListener('click', function () { self.selectSize(sel.dataset.select); self.close(); });
      if (rs) rs.addEventListener('click', function () { self.reset(); self.render(); });
    }, 0);
    return html;
  };
  function fmt(cm, units) { return units === 'metric' ? cm.toFixed(0) + ' cm' : (cm / 2.54).toFixed(1) + ' in'; }
  SizeFinder.prototype.selectSize = function (name) {
    var scope = this.root.closest('.hdt-product-info__list') || document;
    var fieldset = scope.querySelector('.hdt-product-form__input.is-style-size');
    if (!fieldset) return;
    var target = null;
    fieldset.querySelectorAll('.hdt-product-form_value').forEach(function (el) {
      var input = el.previousElementSibling, v = input && input.tagName === 'INPUT' ? input.value : (el.getAttribute('value') || el.textContent);
      if (String(v).trim().toUpperCase() === name) target = el;
    });
    if (target) { target.click(); target.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  };

  function boot() { document.querySelectorAll('.pb-size-finder').forEach(function (r) { if (!r.dataset.ready) { r.dataset.ready = '1'; new SizeFinder(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
